import { v4 as uuidv4 } from "uuid";

const ENDPOINT = "/sse/contentStrategy/seoAgent";
export const MESSAGE_ENDPOINT = ENDPOINT + "/message";
const START_THREAD_ENDPOINT = ENDPOINT + "/newThread";

export const API_REQUEST_METHOD = "POST";

export const API_CREDENTIALS = "include";

export const API_HEADERS = {
    "Content-Type": "application/json",
    "X-Sw-Page": location.href,
    "X-Sw-Page-View-Id": uuidv4(),
};

export const MODAL_CUSTOM_STYLES = {
    content: {
        width: "400px",
        padding: "24px",
    },
};

export const MIN_VOLUME_THRESHOLD = 1000000; // 1M
export const MIN_CLICKS_THRESHOLD = 500;
export const MAX_KEYWORD_COUNT_THRESHOLD = 50;

export const STREAMING_STATUS = {
    INITIAL: "initial",
    STREAMING: "streaming",
    IDLE: "idle",
} as const;
